import PropTypes from 'prop-types';
import React from 'react';
import { useConnect } from 'redux-bundler-hook';

import DefaultTemplateError from './components/DefaultTemplateError';
import DefaultTemplateHeader from './components/DefaultTemplateHeader';
import DefaultTemplateLeftColumn from './components/DefaultTemplateLeftColumn';
import {
  DefaultTemplateContainer,
  DefaultTemplateMainColumn,
  DefaultTemplateMainSection,
  DefaultTemplateOverflowWrapper,
  MobileExpandedTouchTarget,
  StyledSpinner,
  StyledSpinnerWrapper,
} from './styles';

const DefaultTemplate = ({
  showErrorState,
  children,
  className,
  title,
  headerRight,
  contentPadding = undefined,
}) => {
  const {
    doToggleMobileSidebarExpanded,
    mobileSidebarExpanded,
    user: { firstName },
    isLoggedIn,
  } = useConnect(
    'doToggleMobileSidebarExpanded',
    'selectMobileSidebarExpanded',
    'selectUser',
    'selectIsLoggedIn',
  );

  // passed title, or default to welcome message
  const titleOrDefault =
    title || `Welcome back${firstName && `, ${firstName}`}!`;

  if (!isLoggedIn) {
    return (
      <StyledSpinnerWrapper>
        <StyledSpinner color="#6515DD" />
      </StyledSpinnerWrapper>
    );
  }

  return (
    <DefaultTemplateOverflowWrapper>
      <DefaultTemplateContainer
        className={className}
        expanded={mobileSidebarExpanded}
      >
        <DefaultTemplateLeftColumn
          doToggleMobileSidebarExpanded={doToggleMobileSidebarExpanded}
          mobileSidebarExpanded={mobileSidebarExpanded}
        />
        <DefaultTemplateMainColumn expanded={mobileSidebarExpanded}>
          <DefaultTemplateHeader
            doToggleMobileSidebarExpanded={doToggleMobileSidebarExpanded}
            headerRight={headerRight}
            mobileSidebarExpanded={mobileSidebarExpanded}
            title={titleOrDefault}
          />
          <DefaultTemplateMainSection
            expanded={mobileSidebarExpanded}
            padding={contentPadding}
          >
            {showErrorState ? <DefaultTemplateError /> : children}
          </DefaultTemplateMainSection>
        </DefaultTemplateMainColumn>

        <MobileExpandedTouchTarget
          data-test-id="666b0856-1de8-4e18-8357-9db3e2c4af8d"
          expanded={mobileSidebarExpanded}
          onClick={() =>
            doToggleMobileSidebarExpanded({ expanded: !mobileSidebarExpanded })
          }
        />
      </DefaultTemplateContainer>
    </DefaultTemplateOverflowWrapper>
  );
};

DefaultTemplate.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  contentPadding: PropTypes.number,
  headerRight: PropTypes.node,
  showErrorState: PropTypes.bool,
  title: PropTypes.string,
};
DefaultTemplate.defaultProps = {
  children: null,
  className: '',
  contentPadding: undefined,
  headerRight: undefined,
  showErrorState: false,
  title: '',
};

export default DefaultTemplate;
